export default {
  trigger: 'Disparador',
  triggerPlaceholder: 'Inserte el enlace o sube un archivo',
  uploadImage: 'Subir imagen',
  uploading: 'Subiendo...',
  uploadFileError: 'Hubo un error al subir el archivo. Intente nuevamente',
  epigraph: 'Epígrafe',
  epigraphPlaceholder: 'Escribe el epígrafe del disparador',
  pedagogicalGoal: 'Objetivos pedagógicos',
  pedagogicalGoalPlaceholder: 'Escribe los objetivos pedagógicos del recurso',
  classPlan: 'Plan de clases',
  classPlanPlaceholder: 'Escribe el plan de clases del recurso',
  teacher: 'Docente',
  student: 'Estudiante',
  editTeacherForm: 'Editar contenido para docente',
  editStudentForm: 'Editar contenido para estudiante'
}

export const en = {
  trigger: 'Trigger',
  triggerPlaceholder: 'Insert link or upload file',
  uploadImage: 'Upload image',
  uploading: 'Uploading...',
  uploadFileError: 'An error occurred while uploading the file. Please try again',
  epigraph: 'Caption',
  epigraphPlaceholder: 'Caption the trigger',
  pedagogicalGoal: 'Pedagogical goal',
  pedagogicalGoalPlaceholder: 'Type the pedagogical goal of the resource',
  classPlan: 'Lesson plan',
  classPlanPlaceholder: 'Type the lesson plan of the resource',
  teacher: 'Teacher',
  student: 'Student',
  editTeacherForm: 'Edit content for teacher',
  editStudentForm: 'Edit content for student'
}

export const ca = {
  trigger: 'Disparador',
  triggerPlaceholder: 'Insereix l\'enllaç o carrega un arxiu',
  uploadImage: 'Carregar imatge',
  uploading: 'Carregant...',
  uploadFileError: 'S\'ha produït un error carregant l\'arxiu. Torna-ho a intentar',
  epigraph: 'Epígraf',
  epigraphPlaceholder: 'Escriu l\'epígraf del disparador',
  pedagogicalGoal: 'Objectius pedagògics',
  pedagogicalGoalPlaceholder: 'Escriu l\'objectius pedagògics del recurs',
  classPlan: 'Pla de classes',
  classPlanPlaceholder: 'Escriu el pla de classes del recurs',
  teacher: 'Docent',
  student: 'Estudiant',
  editTeacherForm: 'Editar contingut per al docent',
  editStudentForm: 'Editar contingut per a l\'estudiant'
}
